import { Divider, Stack } from "@mui/material";
import React from "react";
import { PermissionType } from "../../../Core/Api/Types/permission-type";
import PermissionAvatar from "./permission-avatar";

export interface PermissionSummaryProps {
  selectedPermissions: PermissionType[];
  allowedPermissions?: PermissionType[];
  variant: "primary" | "success" | "warning" | "error" | "info" | "accent";
  showTooltip?: boolean;
}

const PermissionSummary = (props: PermissionSummaryProps) => {
  const { selectedPermissions, allowedPermissions, variant, showTooltip } = props;

  const _allowedPermissions = React.useMemo(() => {
    return allowedPermissions
      ? [...allowedPermissions].sort()
      : (Object.keys(PermissionType) as Array<PermissionType>).sort();
  }, [allowedPermissions]);

  const activePermissions = React.useMemo(() => {
    return _allowedPermissions.filter((permission) => selectedPermissions.includes(permission));
  }, [selectedPermissions, allowedPermissions]);

  const unActivePermissions = React.useMemo(() => {
    return _allowedPermissions.filter((permission) => !selectedPermissions.includes(permission));
  }, [_allowedPermissions, selectedPermissions]);

  return (
    <>
      <Stack direction="row" spacing={0.5} mt={1} alignItems="center">
        {activePermissions.map((permission) => (
          <PermissionAvatar key={permission} permission={permission} variant={variant} showTooltip={showTooltip} />
        ))}
        {activePermissions.length > 0 && unActivePermissions.length > 0 && (
          <Divider orientation="vertical" sx={{ height: 16 }} />
        )}
        {unActivePermissions.map((permission) => (
          <PermissionAvatar
            key={permission}
            permission={permission}
            variant={variant}
            disabled
            showTooltip={showTooltip}
          />
        ))}
      </Stack>
    </>
  );
};

export default PermissionSummary;
